import React, { useContext } from "react";
import { DataTable, ErrorBoundary, Page, hasActiveFilters, } from "@sscs/ui";
import { formatCount } from "@sscs/utils";
import { filterUpdated, initFilter, paginationUpdated, policyStateFiltered, selectFilter, selectPagination, selectSort, sortUpdated, } from "../../store/policiesSlice";
import { CountBadge } from "../common";
import { ReportContext } from "../context";
import { useReportDispatch, useReportSelector } from "../hooks";
import { useGetPoliciesQuery } from "../services/policies.api";
import { useGetReportSummaryQuery } from "../services/shared.api";
import { getQueryStatus } from "../utils";
import Filter from "./filter/Filter";
import styles from "./policies.module.scss";
import Policy from "./policy/Policy";
const COLUMNS = [
    { id: "audit", label: "Audit", width: "80px" },
    { id: "enabled", label: "Enabled", width: "95px" },
    {
        id: "id",
        label: "ID",
        sortProperty: "id",
        sortId: "policies-sort-id",
        width: "110px",
    },
    { id: "description", label: "Description", width: "100%" },
    {
        id: "policy_category",
        label: "Policy category",
        sortProperty: "policy_category",
        sortId: "policies-sort-policy-category",
        width: "200px",
    },
    {
        id: "violations_count",
        label: "# Files",
        sortProperty: "violations_count",
        sortId: "policies-sort-count",
        startReverse: true,
        width: "115px",
    },
];
const PoliciesContent = () => {
    var _a;
    var _b, _c, _d, _e, _f;
    const dispatch = useReportDispatch();
    const { reportId, diffId, selectedCheck } = useContext(ReportContext);
    const { data: reportSummaryData } = useGetReportSummaryQuery({
        diff_report_id: diffId,
        ui_id: reportId,
    });
    const filter = useReportSelector(selectFilter);
    const sort = useReportSelector(selectSort);
    const pagination = useReportSelector(selectPagination);
    const { data, isLoading, isFetching, isError, error } = useGetPoliciesQuery({
        ui_id: reportId,
        diff_report_id: diffId,
        filter,
        sort,
        pagination,
    });
    const handleSortChange = (sort) => {
        dispatch(sortUpdated(sort));
    };
    return (React.createElement(Page.Root, null,
        React.createElement(Page.Header, { title: React.createElement(React.Fragment, null,
                "Policies",
                " ",
                React.createElement("span", { className: styles["catalogue-version"] },
                    "v",
                    data === null || data === void 0 ? void 0 :
                        data.catalogue)), details: [
                formatCount((_b = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.counters.total_policies) !== null && _b !== void 0 ? _b : 0, "Policy", "Policies"),
                React.createElement(CountBadge, { key: "disabled", count: Object.keys((_c = (_a = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.checks_report.report.scans[selectedCheck]) === null || _a === void 0 ? void 0 : _a.disabled) !== null && _c !== void 0 ? _c : {}).length, label: "Disabled", severity: "none", onClick: () => dispatch(policyStateFiltered("disabled")) }),
                React.createElement(CountBadge, { key: "violated", count: Object.keys((_d = reportSummaryData === null || reportSummaryData === void 0 ? void 0 : reportSummaryData.analysis_summary.policy_statistics) !== null && _d !== void 0 ? _d : {}).length, label: "Violated", severity: "none", onClick: () => dispatch(policyStateFiltered("violated")) }),
            ] }),
        React.createElement(Page.Filters, { found: {
                id: "policies-clear-all-filters",
                count: (_e = data === null || data === void 0 ? void 0 : data.match_count) !== null && _e !== void 0 ? _e : 0,
                initialFilters: initFilter,
                activeFilters: filter,
                onClear: () => dispatch(filterUpdated(initFilter)),
            } },
            React.createElement(Filter, { filter: filter, onChange: (filter) => dispatch(filterUpdated(filter)) })),
        React.createElement(Page.Body, null,
            React.createElement(DataTable, { size: "large", columns: COLUMNS, sort: sort, onSortChange: handleSortChange, empty: {
                    subject: "policies",
                    filters: {
                        active: hasActiveFilters(initFilter, filter),
                        onReset: () => dispatch(filterUpdated(initFilter)),
                    },
                }, status: getQueryStatus({
                    isLoading,
                    isFetching,
                    isError,
                    error,
                    data,
                }), pagination: {
                    id: "policies-pagination",
                    itemCount: (_f = data === null || data === void 0 ? void 0 : data.match_count) !== null && _f !== void 0 ? _f : 0,
                    pagination,
                    onChange: (pagination) => dispatch(paginationUpdated(pagination)),
                } }, data === null || data === void 0 ? void 0 : data.policies.map((policy) => (React.createElement(Policy, { key: policy.id, policy: policy })))))));
};
const Policies = () => {
    return (React.createElement(ErrorBoundary, { key: "policies" },
        React.createElement(PoliciesContent, null)));
};
export default Policies;
//# sourceMappingURL=Policies.js.map